export var SnapshotRangePick;
(function (SnapshotRangePick) {
    SnapshotRangePick["SNAPSHOT_RANGE_PICK_LATEST"] = "SNAPSHOT_RANGE_PICK_LATEST";
    SnapshotRangePick["SNAPSHOT_RANGE_PICK_EARLIEST"] = "SNAPSHOT_RANGE_PICK_EARLIEST";
})(SnapshotRangePick || (SnapshotRangePick = {}));
